// export class EntReservoir {
//    id: number = 0
//   nameRu: string | null = null
//   nameKy: string | null = null
//   yearOfConstruction: number | null = null  //	 Год постройки
//   designCapacity: number | null = null  // Проектная мощность
//   polygonJson: string | null = null
// }



// EntReservoir.ts (класс)
export class EntReservoir {
  id: number = 0;
  nameRu: string | null = null;
  nameKy: string | null = null;
  yearOfConstruction: number | null = null;  
  designCapacity: number | null = null;  
  polygonJson: string | null = null;
}

// ResponseDataTest.ts
export interface ResponseDataTest<T> {
  data: T; 
  status: string;
  message: string;
}
